import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { GetListeBlogs } from '../../helpers/api';
import { UserContext } from '../../contexts/UserContext';
import Loading from '../../components/Loading';
import IconUpdate  from '../../assets/icons/iconUpdateArticle.svg'
const ListBlogs = () => {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);

  const [apiResponse, setApiResponse] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1); 
  const pageSize = 6; 

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await GetListeBlogs(currentPage, pageSize);
        
        if (response?.success) {
          setApiResponse(response?.data || []);
          
          const totalItems = response?.total || 0;
          const calculatedPages = Math.ceil(totalItems / pageSize);
          
          setTotalPage(calculatedPages > 0 ? calculatedPages : 1);
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [currentPage, user?.accessToken]);

  // const handleDelete= async(id)=>{
  //   const res= await DeleteBlogById(id)
  //   console.log('uuu', res)

  // }

  const formatDate = (dateString) => {
    if (!dateString) return "No date";
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };
  const getPageNumbers = () => {
    const maxButtons = 4;
    let startPage = Math.max(1, currentPage - Math.floor(maxButtons / 2));
    let endPage = startPage + maxButtons - 1;

    if (endPage > totalPage) {
      endPage = totalPage;
      startPage = Math.max(1, endPage - maxButtons + 1);
    }

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const visiblePageNumbers = getPageNumbers();

  return (
    <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 py-12 bg-gray-50 min-h-screen">

      {isLoading ? (
        <Loading/>
        // <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        //   {[...Array(pageSize)].map((_, idx) => (
        //     <div key={idx} className="animate-pulse bg-white rounded-2xl p-6 h-64 border border-gray-100 shadow-xs" />
        //   ))}
        // </div>
      ) : apiResponse?.length === 0 ? (
        <div className="text-center py-20 bg-white rounded-2xl border border-gray-200 shadow-sm">
          <p className="text-gray-500 text-lg">No articles found on this page.</p>
        </div>
      ) : (
        <div className={`grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-8 mx-5`}>
          {apiResponse?.map((blog) => (
            <article
              key={blog.id || blog._id}
              className={` ${blog.published ? 'cursor-pointer': 'cursor-default' } group lg:max-w-[400px] flex flex-col justify-between bg-white rounded-2xl p-6 border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 ease-in-out  hover:-translate-y-1`}
            >
              <div onClick={() =>
                {
              if (blog.published)
                 window.open(
                  `https://www.myeasytransfer.com/blog/${blog.slug}`,
                  '_blank',
                  'noopener,noreferrer'
                )}}>
              
                <div className="flex items-center justify-between mb-4">
                  <span className="inline-flex items-center px-4 py-1 rounded-full text-xs font-semibold bg-[#EEF2FF] text-[#5754E5] tracking-wide uppercase">
                    {blog.type || "General"}
                  </span>
                  {blog.published ? (
                    <span className="inline-flex items-center xl:px-4 px-2 py-0.5 rounded-full xl:text-xs text-[10px] font-medium bg-[#ECFDF5] text-[#047857] border border-emerald-200">
                      ● Published
                    </span>
                  ) : (
                    <span className="inline-flex items-center px-4 py-0.5 rounded-full text-xs font-medium bg-amber-50 text-amber-700 border border-amber-200">
                      ● Draft
                    </span>
                  )}
                </div>

                <h3 className="text-xl font-bold text-gray-900 group-hover:text-indigo-600 transition-colors duration-200 line-clamp-2">
                  {blog.blogTitle || "Untitled Post"}
                </h3>

                <p className="mt-3 text-gray-600 text-sm leading-relaxed line-clamp-3">
                  {blog.shortDescription || "No overview available for this article."}
                </p>
              </div>

              <div className="mt-6 pt-4 border-t border-gray-50 flex items-center justify-between text-xs text-gray-400">
                <span>Updated {formatDate(blog.updatedAt)}</span>
                <div className='flex items-center gap-3 '>
                  <img className=' cursor-pointer border-r border-[#D1D1FF] pr-2' 
                  src={IconUpdate}
                  onClick={() => navigate(`/detailarticle/${blog._id}`)}
                    alt=''/>
                   
                <span className="font-semibold cursor-pointer text-indigo-600 group-hover:underline inline-flex items-center gap-1"
                  onClick={() => 
                     window.open( `/previewarticle/${blog._id}`, "_blank", "noopener,noreferrer"
  )
                    // navigate(`/previewarticle/${blog._id}`, '_blank',)
                  }
                >
                  Read article 
                  <svg className="w-3 h-3 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      )}

      {totalPage > 1 && (
        <div className="mt-12 flex items-center justify-between border-t border-gray-200 pt-6 px-2">
          <div className="flex flex-1 justify-between sm:hidden">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="relative inline-flex items-center rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Previous
            </button>
            <button
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPage))}
              disabled={currentPage === totalPage}
              className="relative ml-3 inline-flex items-center rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Next
            </button>
          </div>

          <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
            <div>
              <p className="text-sm text-gray-700">
                 page <span className="font-semibold text-gray-900">{currentPage}</span> of{' '}
                <span className="font-semibold text-gray-900">{totalPage}</span> pages
              </p>
            </div>
            <div>
              <nav className="isolate inline-flex -space-x-px rounded-md shadow-xs bg-white" aria-label="Pagination">
                <button
                  onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                  className="relative inline-flex items-center rounded-l-md px-3 py-2 text-gray-400 border border-gray-300 hover:bg-gray-50 focus:z-20 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                  <span className="sr-only">Previous</span>
                  <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fillRule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clipRule="evenodd" />
                  </svg>
                </button>

                {visiblePageNumbers.map((pageNum) => (
                  <button
                    key={pageNum}
                    onClick={() => setCurrentPage(pageNum)}
                    className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold border focus:z-20 ${
                      currentPage === pageNum
                        ? 'z-10 bg-indigo-600 text-white border-indigo-600'
                        : 'text-gray-900 border-gray-300 bg-white hover:bg-gray-50'
                    }`}
                  >
                    {pageNum}
                  </button>
                ))}

               
                <button
                  onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPage))}
                  disabled={currentPage === totalPage}
                  className="relative inline-flex items-center rounded-r-md px-3 py-2 text-gray-400 border border-gray-300 hover:bg-gray-50 focus:z-20 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                  <span className="sr-only">Next</span>
                  <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clipRule="evenodd" />
                  </svg>
                </button>
              </nav>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ListBlogs;